<template>
  <v-container>
    <Loading v-model="loading"></Loading>

    <h2>科目選択</h2>
    <v-form ref="form">
      <v-container>
        <p class="text-caption-scoped text-left">
        </p>
        <v-row v-for="s in subjects" :key="s.id">
          <v-col>
            <v-text-field :value="s.title" readonly outlined dense></v-text-field>
          </v-col>
          <v-col cols="2" v-if="!event.isTrial">
            <v-checkbox label="免除申請" :value="s.id" v-model="requestOtherSubjectExemption"
                        :rules="[exemptionRule]"
                        :disabled="submitted && !requiredResubmit"></v-checkbox>
          </v-col>
        </v-row>

        <h3>希望受験地</h3>
        <p class="text-caption-scoped text-left">
          <!--          ※受験外国語により選択できる受験地が異なります。施行要領をご確認の上、選択してください。<br>-->
          <!--          ※筆記試験５科目すべてを免除申請する方は「免除」を選択してください。-->
        </p>

        <v-select label="試験受験地" v-model="form.writtenExamArea" :items="AreasOptions"
                  :disabled="submitted && !requiredResubmit"
                  :rules="[rules.required, writtenExamAreaRule]">
        </v-select>
        <!--        <v-select label="口述試験受験地" v-model="form.oralExamArea" :items="oralExamAreasOptions"-->
        <!--                  :disabled="submitted && !requiredResubmit"-->
        <!--                  :rules="[rules.required, oralExamAreaRule]"></v-select>-->

        <template v-if="!event.isTrial">
          <h3>免除科目申請</h3>

          <div class="text-caption-scoped text-left">
            ※免除科目申請がある場合は、下記手順で必ず免除科目申請をしてください。<br>
            <!--            ※過去に免除申請を行った方も、今年度に免除申請を行う場合は必要書類の提出と新規申請が必要となります。<br>-->
            <br>
            <span class="caption-title">【免除科目申請手順】</span><br>
            １．免除科目申請をする「申請の種類」の左側「申請」チェックボックスにチェックを入れてください。<br>
            ２．必要な添付書類、入力項目のご案内が表示されます。表示された書類のアップロード、項目の入力をしてください。<br>
            <p class="red--text ml-8">修了予定や卒業見込みの場合は、「修了見込み」「卒業見込み」にチェックをし願書提出をしてください。<br>
              試験に合格しますと「仮合格」の扱いとなりますので、「修了見込み」「卒業見込み」にチェックを入れた項目は、
              当該試験実施の翌年4月30日までに修了証明書等をアップロードにて提出をしてください。期限までに提出しなければ、
              「仮合格」は取消となります。</p>
            ３．ページ下部「確定する」ボタンをクリック<br>
            <p class="ml-8">※登録内容に不備がない場合は、画面上部に「確定しました」と表示が出て、マイページに移動します。<br>
            ※表示が出ない場合は、必須項目に未入力・未登録の項目があります。<br> 該当箇所に赤字で不備内容が表示されますので、表示を確認の上、全て入力・登録をしてください。</p>
            <br>
            <span class="caption-title">【免除書類のアップロード手順】</span><br>
            ①申請したい免除項目の「申請」にチェック<br>
            <span class="red--text">（現職日本語教師に該当する方は、下記の申請の種類「現職日本語教師」の左隣の申請にチェックをいれてください）</span><br>
            ②クリップマークをクリック<br>
            ③アップロードしたいファイルを選択しアップロード<br>
            ④クリップマークの上にアップロードしたファイル名が表示される<br>
            　（ファイルのアップロード完了です）<br>
            ⑤ファイルを複数アップロードする場合は②～④の操作を繰返す<br>
            ※１ファイル20MBまで。
          </div>
        </template>
        <template v-else>
          <h3>試行試験受験者アンケート</h3>

          <p class="text-caption-scoped text-left">
            下記の質問にお応えください。
          </p>
        </template>

        <v-data-table class="text-left"
                      :headers="tableHeader"
                      :items="filteredExemptions"
                      :expanded="expandedItems"
                      :items-per-page="-1"
                      item-key="id"
                      disable-sort
                      hide-default-footer>
          <template v-slot:item.id="{item}">
            <v-checkbox v-model="form.exemptions" :value="item.id"
                        :disabled="(submitted && !requiredResubmit) || event.isTrial"
                        @change="checkConflicts(item.id, $event)"
            ></v-checkbox>
          </template>
          <template v-slot:item.target="{item}">
            <p class="text-pre-line">{{ item.target }}</p>
          </template>
          <template v-slot:expanded-item="{headers, item}">
            <td :colspan="headers.length" class="pa-5">

              <p class="text-caption-scoped text-left text-pre-line" v-html="item.documents"></p>

              <template v-if="form.exemptions.includes(item.id) && !!item.schema">
                <v-jsf :schema="item.schema"
                       :options="{...vjsfOptions,...additionalRules(item)}"
                       v-model="form.exemptionData[item.id]">
                  <template v-slot:ファイルアップロード="{label,schema}">
                    <span v-for="item in getExemptionFiles(item.id)" :key="item.fileId" class="mr-1">
                      <v-chip :href="item.url"
                              :close="!submitted || requiredResubmit"
                              @click:close="removeFromExemptionFiles(item)">
                        {{ item.key|fileName }}
                        </v-chip>
                    </span>
                    <v-file-input show-size
                                  :label="label"
                                  required
                                  multiple
                                  :disabled="submitted && !requiredResubmit"
                                  :rules="[rules.filesWithMinItems(item.id, schema.minItems)]"
                                  @change="upload($event, item.id)"></v-file-input>
                  </template>

                  <template v-slot:custom-routec="context">
                    <CustomRoute type="C" v-bind="context"></CustomRoute>
                  </template>
                  <template v-slot:custom-routed1="context">
                    <CustomRoute type="D1" v-bind="context"></CustomRoute>
                  </template>
                  <template v-slot:custom-routed2="context">
                    <CustomRoute type="D2" v-bind="context"></CustomRoute>
                  </template>

                </v-jsf>
              </template>

              <template v-else-if="form.exemptions.includes(item.id)">
                <span v-for="item in getExemptionFiles(item.id)" :key="item.fileId" class="mr-1">
                  <v-chip :href="item.url"
                          :close="!submitted || requiredResubmit"
                          @click:close="removeFromExemptionFiles(item)">
                    {{ item.key|fileName }}
                    </v-chip>
                </span>
                <v-file-input show-size
                              label="ファイルアップロード"
                              required
                              multiple
                              :disabled="submitted && !requiredResubmit"
                              :rules="[rules.files(item.id)]"
                              @change="upload($event, item.id)"></v-file-input>
              </template>
            </td>
          </template>
        </v-data-table>

        <p class="text-caption-scoped text-left my-8">
          ※「確定する」ボタンをクリックしても画面上部に「確定しました」と表示が出ない場合は、<br/>
          必須項目に未入力・未登録の項目があります。<br/>
          該当箇所に赤字で不備内容が表示されますので、表示を確認の上、全て入力・登録をしてください。<br/>
          ※願書提出後の「受験科目、受験地、免除申請」の変更・追加はできません。<br />
          <span class="red--text">
            ※出願時と修了証書や証明書に記載のある⽒名が異なる場合は、変更や通称名の使⽤が分かる証明書（⼾籍全部・個⼈事項証明書[⼾籍謄抄本]・免許証の表裏等）の提出を併せてお願いします。やむを得ず出願後に提出をされる際には、アップロードができなくなっておりますので、事務局までメールでご連絡ください。
          </span>
        </p>

        <v-btn to="/mypage" class="mx-2">マイページに戻る</v-btn>
        <v-btn @click.stop="save" class="mx-2" v-if="!submitted">保存する</v-btn>
        <v-btn color="primary" @click.stop="submit" class="mx-2" v-if="!submitted || requiredResubmit">確定する</v-btn>

      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import axios from 'axios'
import Loading from '../components/Loading'
import VJsf from '@koumoul/vjsf/lib/VJsf.js'
import Rules from '../mixins/RulesMixin'
import SubjectSelection from '../mixins/SubjectSelection'
import {mapGetters} from "vuex";
import _ from 'lodash'
import CustomRoute from "@/components/CustomRoute.vue";

export default {
  components: {CustomRoute, Loading, VJsf},
  mixins: [Rules, SubjectSelection],
  data() {
    return {
      loading: true,
      form: {
        language1: '',
        language2: '',
        chineseType: '',
        requestedSubjects: [],
        exemptions: [],
        exemptionFiles: [],
        exemptionData: {},
        writtenExamArea: '',
        oralExamArea: '',
        data: {}
      },
      schemaData: [],
      expanded: [],
      tableHeader: [
        {text: '申請', value: 'id'},
        {text: '申請の種類', value: 'title'},
        {text: '科目', value: 'subjectName'},
        {text: '免除対象者', value: 'target'},
        // {text: '提出書類', value: 'documents'},
        // {text: '免除申請有効期限有無', value: 'hasExpired'},
        // {text: '免除申請有効期限', value: 'expiredAt'}
      ],
      writtenExamAreaRule: (v) => !!v || (this.canAvoidWrittenExam && v === 0) || "必須項目です",
      oralExamAreaRule: (v) => this.oralExamAreasOptions.some(a => a.value == v) || "必須項目です",
      exemptionRule: () => {
        return this.checkSubjectSelect() || "応用試験のみの免除はできません"
      },
      additionalRules(item) {
        return {
          rules: {
            otherRoute: (v) => {
              let data = this.form.exemptionData[item.id]
              let route = data && (data["日本語教員養成課程機関"] || data["日本語養成課程機関"])
              return !!v || route !== "下記以外の機関等" || "必須項目です"
            }
          },
          "markdownit": {
            "html": true
          }
        }
      }
    }
  },
  async created() {
    await this.fetchSubjects()
    await this.fetchSaved()
    if (this.event.isTrial) {
      this.form.exemptions = this.filteredExemptions.map(v => v.id)
    }
    this.loading = false
  },
  computed: {
    ...mapGetters([
      'event'
    ]),
    submitted() {
      return this.$store.getters.submitted
    },
    requiredResubmit() {
      return this.$store.getters.requiredResubmit
    },
    uploadedSubjects() {
      return this.form.exemptions.map(value => {
        return this.exemptions.find(v => v.id == value)
      }).map(v => {
        if (v.schema && v.schema["x-required"]) {
          let requiredEx = this.exemptions.find(v2 => v2.title == v.schema["x-required"])
          if (!requiredEx || !this.form.exemptions.includes(requiredEx.id)) {
            return
          }
        }
        if (v.schema && v.schema["x-function"]) {
          let model = this.form.exemptionData[v.id] || {}
          try {
            let f = new Function(v.schema["x-function"]["arguments"], v.schema["x-function"]["body"])
            return f(model)
          } catch (e) {
            console.error(e)
          }
        }
        return v.subjectName
      }).flat()
    },
    documentRequiredSubjects() {
      return this.requestedSubjects.map(s => this.subjects.find(v => v.id == s))
    },
    lackedDocumentSubjects() {
      let exemptions = this.form.exemptions.map(value => {
        return this.exemptions.find(v => v.id == value)
      })
      for (let v of exemptions) {
        if (v.schema && v.schema["x-required"]) {
          let requiredEx = this.exemptions.find(v2 => v2.title == v.schema["x-required"])
          if (!this.form.exemptions.includes(requiredEx.id)) {
            return [requiredEx.title];
          }
        }
      }
      return this.documentRequiredSubjects.filter(s => {
        return !this.uploadedSubjects.some(value => value === s.title)
      }).map(s => s.title)
    },
    validateRequiredDocuments() {
      let ret;
      ret = this.documentRequiredSubjects.every(s => {
        return this.uploadedSubjects.some(value => value === s.title)
      })
      if(this.lackedDocumentSubjects.length > 0){
        ret = false
      }
      return ret
    },
    validateRoute(){
      //現職日本語教師のみ選択時
      if(this.form.exemptions.length == 1 &&  this.exemptions.some(v => v.id == this.form.exemptions[0] && v.title === "現職日本語教師")){
        return false
      }
      return true
    }
  },
  watch: {},
  methods: {
    async fetchSaved() {
      let {data} = await axios.get('/api/subject/draft')
      if (data) {
        this.form = Object.assign(this.form, data)
        this.schemaData = this.form.exemptionData
        if (data.language1 && data.requestedSubjects.includes(data.language1)) {
          this.requestFirstLanguageExemption = true
        }
        if (data.language2 && data.requestedSubjects.includes(data.language2)) {
          this.requestSecondLanguageExemption = true
        }
        this.requestOtherSubjectExemption = this.nonLanguageSubjects
          .filter(v => data.requestedSubjects.includes(v.id))
          .map(v => v.id)
      }
    },
    async upload(file, exemptionId) {
      if (!file) {
        this.form.exemptionFiles = this.form.exemptionFiles.filter(v => v.id != exemptionId)
        return
      }
      if (Array.isArray(file)) {
        this.loading = true
        try {
          for (let i in file) {
            await this.upload(file[i], exemptionId)
          }
        } catch (e) {
          console.error(e)
        }
        this.loading = false
        return
      }
      if (file.size > 20971520) {
        alert('ファイルサイズは20MB以下でアップロードしてください')
        return
      }
      let params = new FormData()
      params.append('file', file)
      let {data} = await axios.post('/api/visitor/file/upload', params)
      this.form.exemptionFiles.push({
        id: exemptionId,
        fileId: data.id,
        key: file.name
      })
    },
    getExemptionFile(id) {
      return this.form.exemptionFiles.find(v => v.id == id)
    },
    getExemptionFiles(id) {
      return this.form.exemptionFiles.filter(v => v.id == id)
    },
    hasExpectedCompletion(id) {
      //expectedCompletionが１つ以上あり、すべてチェック済みじゃないとエラー
      let data = this.form.exemptionData[id]
      let exemption = this.exemptions.find(v => v.id == id)
      let items = _(exemption.schema.properties).filter(v => v['x-type'] == "expectedCompletion")
      if(items.size() < 1) return false
      return _(exemption.schema.properties)
        .every(((v, k) => {
          if (v['x-type'] == "expectedCompletion") {
            return !!data[k]
          }
          return true
        }))
    },
    getExemptionFileUrl(id) {
      let f = this.getExemptionFile(id)
      return f && f.url
    },
    removeFromExemptionFiles(item) {
      this.form.exemptionFiles = this.form.exemptionFiles.filter(v => v.fileId != item.fileId)
    },
    async save() {
      try {
        this.form.requestedSubjects = this.requestedSubjects
        this.form.chineseType = this.selectChinese ? this.form.chineseType : ""
        await axios.post('/api/subject/save', this.form)
        this.$emit('toast', '保存しました')
      } catch (e) {
        console.error(e)
        this.$emit('error', 'エラーが発生しました。しばらくしてから再度お試しください')
      }
    },
    async submit() {
      try {
        if (!this.$refs.form.validate()) {
          this.$emit('error', '入力項目にエラーがあります')
          return
        }
        if (!this.validateRequiredDocuments) {
          this.$emit('error', '免除書類に不足があります: ' + this.lackedDocumentSubjects.join(', '))
          return
        }
        if (!this.validateRoute) {
          this.$emit('error', 'いずれかのルートを選択してください')
          return
        }
        this.form.requestedSubjects = this.requestedSubjects
        this.form.chineseType = this.selectChinese ? this.form.chineseType : ""
        await axios.post('/api/subject/submit', this.form)
        this.$emit('toast', '確定しました')
        await this.$router.push('/mypage')
      } catch (e) {
        console.error(e)
        this.$emit('error', 'エラーが発生しました。しばらくしてから再度お試しください')
      }
    },
    checkSubjectSelect() {
      //応用試験のみの免除はできません
      return !(this.requestedSubjectItems.some((v) => v.title === "応用試験") && !this.requestedSubjectItems.some((v) => v.title === "基礎試験"))
    },
    checkConflicts(v, event) {
      //同時に選択できないものの選択を外す
      if (event.includes(v)) {
        let clicked = this.exemptions.find(e => e.id === v)
        let ret = this.filteredExemptions
          .filter(e => {
            return this.form.exemptions.includes(e.id)
          })
          .filter(e => {
            if (e.id !== v && clicked.subjectName === e.subjectName) {
              //同じ対象科目なら解除
              return false
            }
            return true
          })
          .map(e => e.id)
        this.form.exemptions = ret
      }
    }
  }
}
</script>
<style scoped>
v-simple-table {
  text-align: left;
}

.caption-title {
  text-align: left;
  font-size: 130%;
  font-weight: bold;
  /*color: #959595;*/
}
</style>
